import axios from "axios";

const Ville_API_BASE_URL = "https://doclicapp.herokuapp.com/api/auth/city";
const SCREUR_API_BASE_URL = "https://doclicapp.herokuapp.com/villes/secteurs";
const Analyse_API_BASE_URL = "https://doclicapp.herokuapp.com/analyse/noncovid";
const AnalyseCOVID_API_BASE_URL =
  "https://doclicapp.herokuapp.com/analyse/covid";
const Laboratory_API_BASE_URL =
  "https://doclicapp.herokuapp.com/analyse/laboratory";

class ServiceMember {
  getVille() {
    return axios.get(Ville_API_BASE_URL);
  }
  getSecteur(id) {
    return axios.get(SCREUR_API_BASE_URL + "/" + id);
  }
  getAnalyse() {
    return axios.get(Analyse_API_BASE_URL);
  }
  getAnalyseCovid() {
    return axios.get(AnalyseCOVID_API_BASE_URL);
  }
  getLaboratory() {
    return axios.get(Laboratory_API_BASE_URL);
  }
}

export default new ServiceMember();
